var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5707 8.31376L18.5915 12.4098C18.6458 12.5293 18.7653 12.6053 18.8848 12.6271L23.4046 13.2789C23.7305 13.3224 23.8609 13.7244 23.6219 13.9526L20.3516 17.1359C20.2538 17.2228 20.2103 17.3532 20.2429 17.4836L21.0143 21.9816C21.0687 22.3075 20.7319 22.5466 20.4385 22.3945L16.3968 20.265C16.2773 20.1998 16.1469 20.1998 16.0274 20.265L11.9857 22.3945C11.6924 22.5466 11.3556 22.2967 11.4099 21.9816L12.1813 17.4836C12.203 17.3532 12.1596 17.2228 12.0727 17.1359L8.80237 13.9526C8.56334 13.7244 8.69372 13.3224 9.01966 13.2789L13.5394 12.6271C13.6698 12.6053 13.7784 12.5293 13.8327 12.4098L15.8536 8.31376C15.9948 8.02041 16.4185 8.02041 16.5598 8.31376H16.5707Z",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3441 8.31376L39.3649 12.4098C39.4193 12.5293 39.5388 12.6053 39.6583 12.6271L44.178 13.2789C44.504 13.3224 44.6343 13.7244 44.3953 13.9526L41.125 17.1359C41.0272 17.2228 40.9838 17.3532 41.0164 17.4836L41.7878 21.9816C41.8421 22.3075 41.5053 22.5466 41.2119 22.3945L37.1703 20.265C37.0507 20.1998 36.9204 20.1998 36.8009 20.265L32.7592 22.3945C32.4658 22.5466 32.129 22.2967 32.1833 21.9816L32.9547 17.4836C32.9765 17.3532 32.933 17.2228 32.8461 17.1359L29.5758 13.9526C29.3368 13.7244 29.4672 13.3224 29.7931 13.2789L34.3128 12.6271C34.4432 12.6053 34.5519 12.5293 34.6062 12.4098L36.627 8.31376C36.7683 8.02041 37.192 8.02041 37.3332 8.31376H37.3441Z",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1332 8.31376L60.154 12.4098C60.2083 12.5293 60.3278 12.6053 60.4473 12.6271L64.9671 13.2789C65.293 13.3224 65.4234 13.7244 65.1844 13.9526L61.9141 17.1359C61.8163 17.2228 61.7728 17.3532 61.8054 17.4836L62.5768 21.9816C62.6312 22.3075 62.2944 22.5466 62.001 22.3945L57.9593 20.265C57.8398 20.1998 57.7094 20.1998 57.5899 20.265L53.5482 22.3945C53.2549 22.5466 52.9181 22.2967 52.9724 21.9816L53.7438 17.4836C53.7655 17.3532 53.7221 17.2228 53.6352 17.1359L50.3649 13.9526C50.1258 13.7244 50.2562 13.3224 50.5822 13.2789L55.1019 12.6271C55.2323 12.6053 55.3409 12.5293 55.3952 12.4098L57.4161 8.31376C57.5573 8.02041 57.981 8.02041 58.1223 8.31376H58.1332Z",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2446 1H6.61707C3.50975 1 1 3.52062 1 6.61707V23.9355C1 27.0428 3.52062 29.5525 6.61707 29.5525H10.9195L16.2758 36.7124L21.6321 29.5525H67.3727C70.48 29.5525 72.9898 27.0319 72.9898 23.9355V6.61707C72.9898 3.50975 70.4691 1 67.3727 1H13.2446Z",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7043 54.4557C21.7043 57.4978 19.2381 59.9641 16.1959 59.9641C13.1538 59.9641 10.6875 57.4978 10.6875 54.4557C10.6875 51.4136 13.1538 48.9473 16.1959 48.9473C19.2381 48.9473 21.7043 51.4136 21.7043 54.4557Z",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25781 68.7959C6.83364 63.8199 11.06 59.9629 16.1882 59.9629C21.3163 59.9629 25.7057 63.972 26.1512 69.0893",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4213 57.7888C31.4213 66.1872 24.6091 72.9994 16.2106 72.9994C7.81219 72.9994 1 66.1872 1 57.7888C1 49.3903 7.81219 42.5781 16.2106 42.5781C24.6091 42.5781 31.4213 49.3903 31.4213 57.7888Z",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3103 49.457H40.4648C38.9872 49.457 37.7812 48.2619 37.7812 46.7734C37.7812 45.2958 38.9764 44.0898 40.4648 44.0898H70.3103C71.7879 44.0898 72.9939 45.285 72.9939 46.7734C72.9939 48.251 71.7987 49.457 70.3103 49.457Z",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5896 55.1055H70.404C71.8816 55.1055 73.0876 56.3006 73.0876 57.7891C73.0876 59.2667 71.8925 60.4727 70.404 60.4727H40.5586C39.081 60.4727 37.875 59.2775 37.875 57.7891C37.875 56.3115 39.0701 55.1055 40.5586 55.1055H68.5896Z",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.239 71.4805H40.6211C39.1435 71.4805 37.9375 70.2853 37.9375 68.7969C37.9375 67.3193 39.1326 66.1133 40.6211 66.1133H70.4665C71.9441 66.1133 73.1501 67.3084 73.1501 68.7969C73.1501 70.2745 71.955 71.4805 70.4665 71.4805H44.2499H44.239Z",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReference);
export default __webpack_public_path__ + "static/media/reference.2e7d79e28b40eb725cb8e78ac2f0ebb5.svg";
export { ForwardRef as ReactComponent };